import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class MobileHeader {
	constructor(trigger = '.btn-hamburger', searchTrigger = '.main-header__search-mobile', pbody = 'body', listParent = '.menu-item-has-children > a', listChild = '.main-header__nav-mobile .sub-menu > li.menu-item-type-post_type > a.open') {
		this.trigger = trigger;
		this.searchTrigger = searchTrigger;
		this.pbody = pbody;
		this.listParent = listParent;
		this.listChild = listChild;
	}
	init() {
		$(this.trigger).on('click', this.setNavState);
		$(this.searchTrigger).on('click', this.setNavState);
		$(this.listParent).on('click', this.setListState);
		$(this.listChild).on('click', this.setListStateChild);
	}
	setNavState(e) {
		e.preventDefault();
		const body = $('body');
		const searchT = $('.main-header__search-mobile');
		const hamburgerT = $('.btn-hamburger');
		document.querySelector('.main-header').classList.remove('main-header-default');
		if ($(this).hasClass('open')) {
			MobileHeader.hideWrapper(this, body);
			lockScroll.unlock();
		} else {
			MobileHeader.showWrapper(this, body, searchT, hamburgerT);
			lockScroll.lock();
		}
	}
	setListState(e) {
		e.preventDefault();

		if (!$(this).hasClass('open')) {

			let listParentOpen = document.querySelector('.menu-item-has-children > a.open');
			if (listParentOpen) {
				listParentOpen.classList.remove('open');
			}

			$(this).addClass('open');
		} else {
			$(this).removeClass('open');
		}
	}
	setListStateChild(e) {
		e.preventDefault();

		let listParentNodeOpen = document.querySelector('.menu-item-has-children > a.open');
		if (listParentNodeOpen && (document.documentElement.clientWidth < 1200)) {
			listParentNodeOpen.classList.remove('open');
		}
	}
	static hideWrapper(el, body) {
		$(el).removeClass('open');
		body.removeClass('overlayed');
		$(el).next().removeClass('active');
		$('#menu-mobile-main-nav a.open').removeClass('open');
		$('#searchform input').val('Search');
	}
	static showWrapper(el, body, searchT, hamburgerT) {
		if ($(el).hasClass('main-header__search-mobile') && hamburgerT.hasClass('open')) {
			hamburgerT.removeClass('open');
			hamburgerT.next().removeClass('active');
			$('#menu-mobile-main-nav a.open').removeClass('open');
		} else if ($(el).hasClass('btn-hamburger') && searchT.hasClass('open')) {
			searchT.removeClass('open');
			searchT.next().removeClass('active');
			$('#searchform input').val('Search');
		}
		$(el).addClass('open');
		body.addClass('overlayed');
		$(el).next().addClass('active');
	}
	resized() {
		if (!$(this.trigger).is(':visible') && $(this.trigger).hasClass('open')) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
	}
	hideOutsideClick(e) {
		if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
			const container = $('.main-header');
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				MobileHeader.hideWrapper(this.trigger, $(this.pbody));
			}
		}
	}
}

export default MobileHeader;
